module.exports = __webpack_public_path__ + "img/customer.78a8bdd5.png";